export default "__VITE_ASSET__69f66b4d__"